var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.275001 6.64167L4.85833 11.225C5.225 11.5917 5.775 11.5917 6.14167 11.225C6.50833 10.8583 6.50833 10.3083 6.14167 9.94167L3.11667 6.91667L10.0833 6.91667C10.6333 6.91667 11 6.55 11 6C11 5.45 10.6333 5.08333 10.0833 5.08333L3.11667 5.08333L6.14167 2.05833C6.50833 1.69167 6.50833 1.14167 6.14167 0.775C5.775 0.408333 5.225 0.408333 4.85834 0.775L0.275001 5.35833C-0.0916657 5.63333 -0.0916658 6.275 0.275001 6.64167Z",
    fill: "#F15D36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.28a292d6ce849187a33f753dcad737a1.svg";
export { ForwardRef as ReactComponent };